import type { History } from 'history';

function replaceUrl(history: History, path: string) {
  const url = new URL(path, 'https://example.com');

  const { searchParams } = new URL(
    history.location.search,
    'https://example.com'
  );

  searchParams.forEach((value, key) => {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  });

  history.replace(url.pathname + url.search);
}

export { replaceUrl };
